const firstLine = ['#f6746d', '#fce3e2', '#f68000', '#fce7cc', '#f9c500', '#f8edc0', '#93ad00', '#e3f09f', '#4ebd44', '#d3f5cd', '#4cbeab', '#c9f2ec', '#47b1e9', '#ceeffd', '#81a3ff', '#e1e9ff', '#e477b9', '#fce2f2', '#b591fd', '#eee6ff', '#90959e', '#eff0f1'];

const secondLine = ['#fce3e2', '#cf372b', '#fce7cc', '#9d4d0a', '#f8edc0', '#825a00', '#e3f09f', '#93ad00', '#d3f5cd', '#4ebd44', '#c9f2ec', '#237062', '#ceeffd', '#246a96', '#e1e9ff', '#2c58f4', '#fce2f2', '#b1267a', '#eee6ff', '#7937f4', '#eff0f1', '#383c43'];

const thirdLine = ['#f8c6c3', '#cf372b', '#f9c387', '#9d4d0a', '#f9de77', '#825a00', '#c9dd55', '#5d6d00', '#9ee596', '#42a10f', '#81e8d8', '#237062', '#a0dcfe', '#246a96', '#c4d4ff', '#2c58f4', '#f4c4e2', '#b1267a', '#dbc9ff', '#7937f4', '#dee0e3', '#383c43'];

const fourthLine = ['#eb4840', '#fce3e2', '#e46c00', '#fce7cc', '#d39800', '#f8edc0', '#7c9200', '#e3f09f', '#46a63f', '#d3f5cd', '#39a893', '#c9f2ec', '#3796cc', '#ceeffd', '#5a84fe', '#e1e9ff', '#d757a6', '#fce2f2', '#9d70f4', '#eee6ff', '#656a73', '#eff0f1'];

const fifthLine = ['#cf372b', '#fce3e2', '#9d4d0a', '#fce7cc', '#825a00', '#f8edc0', '#5d6d00', '#e3f09f', '#42a10f', '#9ee596', '#237062', '#c9f2ec', '#246a96', '#ceeffd', '#2c58f4', '#e1e9ff', '#b1267a', '#fce2f2', '#7937f4', '#eee6ff', '#383c43', '#eff0f1'];

function changeDark(colorList, type) {
  return colorList.map((colorItem, index) => {
    if (index % 2 === 1) {
      if (type === 'dark') {
        return '#000';
      }
      return '#fff';
    }
    return colorItem;
  });
}

const firstWhite = changeDark(firstLine, 'white');
const secondDark = changeDark(secondLine, 'dark');
const thirdDark = changeDark(thirdLine, 'dark');
const forthWhite = changeDark(fourthLine, 'white');
const fifthWhite = changeDark(fifthLine, 'white');

console.log('secondDark', secondDark);
console.log('thirdDark', thirdDark);

// const colorArray = [...firstLine, ...secondLine, ...thirdLine, ...fourthLine, ...fifthLine];
const colorArray = [...firstWhite, ...secondDark, ...thirdDark, ...forthWhite, ...fifthWhite];

const colorResult = colorArray.reduce((acc, current, index) => {
  if (index % 2 === 0) {
    acc.push({
      background: current,
      color: colorArray[index + 1]
    });
  }
  return acc;
}, []);

export default colorResult;
